import { getUrlParamsBySearch } from "../../utils/index";
import request from "../../utils/request";
import { msgValus } from "../../lang";
import msgData from "../../lang/data";
import { getFinger } from "../../utils/storage";
function getParams() {
  let params = getUrlParamsBySearch(window.location.search);
  params.surveyId = params.surveyCode || params.surveyId || params.id;
  if (params.surveyId === "nps") params.surveyId = 2;
  params.language = params.language || window._Front_Questionnaire_h5_config.defaultLang;
  return params;
}

let urlOpts = {
  baseUrl: window._Front_Questionnaire_h5_config.api,
};

let actions = {
  getSurvey: (preview) => {
    let params = {
      ...getParams(),
      uuid: getFinger(),
    };
    if (preview === true) {
      params.preview = 1;
    }
    return request.get("/getQuestionnaire", params, urlOpts);
  },
  upload: (file) => {
    let formData = new FormData();
    formData.append("file", file);
    return request
      .post("/file/upload?directName=questionnaire", formData, {
        ...urlOpts,
        headers: { "content-type": "multipart/form-data" },
      })
      .then((data) => data?.url);
  },
  postData: (data) => {
    let params = {
      ...getParams(),
      uuid: getFinger(),
    };
    return request.post("/saveActive/v2", { ...params, ...data }, urlOpts);
  },
  getLanguageInfo: () => {
    let { language } = getParams();
    return request
      .post(
        "/autoTranslation",
        { destLang: language, textList: msgValus },
        urlOpts
      )
      .then((data) => {
        let saveData = {};
        Object.keys(msgData).forEach((key) => {
          saveData[key] = data[msgData[key]];
        });
        return saveData;
      });
  },
};

export default actions;
